import { Box, styled } from '@chilipiper/design-system'

export const StyledStickyAvatar = styled(Box)`
  position: sticky;
  bottom: 0;
`
